export default {
  state: {
    loader: {
      show: false
    }
  },
  mutations: {
    setLoaderData (state, data) {
      for (let field in data) {
        state.loader[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/global/loader.js